<template>
	<div class="homeDetail p-t-10">
		<div class="ls-flex-col-center bg-c-f6f6f6 p-tb-20">
			<div class="max-width bg-c-fff b-c-ccc ls-flex ls-al-center p-20">
				<router-link to="/" class="">
					<div class="fs-16 f-333">首页</div>
				</router-link>
				<router-link :to="typeId == 999999999 ? `/Search` : `/HomeEdit?typeId=${typeId}`" class="">
					<div class="fs-16 f-333">>>{{typeName || '时政'}}</div>
				</router-link>
			</div>
			
		</div>
		
		<div class="ls-flex-col-center p-tb-20">
			<div class="max-width ls-flex">
				<div class="ls-flex-flex p-t-40">
					<DetailVue :obj="info" :change="next"></DetailVue>
				</div>
				<div class="m-l-20" style="width: 350px;">
					<div class="b-c-E0DFDD p-15">
						<div class="fs-18 f-000 m-b-20">资讯推荐</div>
						<div class="p-lr-15" v-for="(item,index) in dataTextList" :key="index">
							<router-link :to="`/HomeDetail?id=${item.id}`" class="ls-flex-flex">
								<div class="text-ellipsis-1 fs-16 f-333 m-b-20">{{item.title || ''}}</div>
							</router-link>
						</div>
					</div>
					<div style="height: 845px;" class="b-c-E0DFDD p-15 ls-flex-col">
						<div class="fs-18 f-000 m-b-20">资讯热点</div>
						<div class="ls-flex-flex overflow-y">
							<div class="ls-flex ls-flex-rw ls-jc-space-between">
								<div class="ls-flex" style="width: 152px;" v-for="(item,index) in dataImageList" :key="index">
									
									<router-link :to="`/HomeDetail?id=${item.id}`" class="ls-flex-flex">
										<div class="b-c-ccc" style="height: 120px;">
											<div class="w-100 h-100 bg-i-center-cover" :style="{backgroundImage:`url(${item.image})`}"></div>
										</div>
										<div class="text-ellipsis-2 fs-14 f-333 l-h-30 ta-center m-tb-10">{{item.title || ''}}</div>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="max-width p-t-40">
				
			</div>
		</div>
	</div>
</template>

<script>
	import {getNewsInfo, getNewsList} from "@/api/api.js";
	import DetailVue from "../components/Detail.vue"; 
	export default {
		data() {
			return {
				dataImageList:[],
				dataTextList:[],
				info:{},
				typeName:'',
				typeId:''
			}
		},
		components: {
			DetailVue
		},
		methods: {
			getDate(id){
				let _self = this;
				_self.typeId = window.localStorage.getItem('typeId');
				getNewsList({
					type_id:_self.typeId == 999999999 ? '1' : _self.typeId,
					istop:0,
					isrecommend:1,
					isheadline:0,
					is_image:0,
					limit:10,
					page:1
				}).then((res) => {
					if (res.code == 1) {
						if(res.data.data && res.data.data.length > 0){
							_self.dataTextList = res.data.data;
						}
					}
				});
				getNewsList({
					type_id:_self.typeId == 999999999 ? '1' : _self.typeId,
					istop:0,
					isrecommend:0,
					isheadline:1,
					is_image:1,
					limit:10,
					page:1
				}).then((res) => {
					if (res.code == 1) {
						if(res.data.data && res.data.data.length > 0){
							_self.dataImageList = res.data.data;
						}
					}
				});
				getNewsInfo({id:id}).then((res) => {
					_self.info = res.data;
					_self.typeName = res.data.info.type_info.name;
					// + res.data.info.type_one
					document.title = res.data.info.title + '	' + res.data.info.type_info.name + '-' + '中北新闻网';
				});
			},
			next(id){
				this.getDate(id);
				this.toTop();
			},
			// 返回顶部
			toTop() {
				document.documentElement.scrollTop = 0;
				this.show = false;
			},
		},
		mounted() {
			let _self = this;
			
		},
		created() {
			this.getDate(this.$route.query.id);
		},
		watch: {
			$route: {
				handler: function (val, oldVal) {
					//刷新页面
					this.getDate(val.query.id);
				},
				immediate: true,
				// 深度观察监听
				deep: true,
			},
			'$store.state.typeName': {
				handler: function (val, oldVal) {
					//刷新页面
					this.typeName = val;
				},
				immediate: true,
				// 深度观察监听
				deep: true,
			}
		},
	};
</script>

<style lang="scss">
	.homeDetail {
		width: 100%;
		height: auto;
		
		.dot{
			width: 7px;
			height: 7px;
			background: #DDDDDD;
			border-radius: 50%;
			margin-right: 10px;
		}
		.line{
			height: 1px;
			background: #DBDBDB;
		}
		.overflow-y{
			overflow-y: auto;
		}
		.overflow-y::-webkit-scrollbar {
		  width: 0;
		}
	}
</style>